<script setup lang="ts">
type Props = {
  current?: number
  total?: number
  previousHref?: string
  nextHref?: string
  previousDisabled?: boolean
  nextDisabled?: boolean
  class?: string
  vertical?: boolean
}

const props = defineProps<Props>()

const previousComponent = computed(() => {
  if (props.previousHref) return resolveComponent('NuxtLink')

  return undefined
})

const nextComponent = computed(() => {
  if (props.nextHref) return resolveComponent('NuxtLink')

  return undefined
})

const classes = computed(() => ({
  'app-pagination': true,
  'app-pagination--vertical': props.vertical,
  [`${props.class}`]: !!props.class,
}))

const emit = defineEmits<{
  (e: 'previous'): void
  (e: 'next'): void
}>()

const previous = () => emit('previous')
const next = () => emit('next')
</script>

<template>
  <div :class="classes">
    <AppButtonIconRounded
      class="app-pagination__prev"
      :as="previousComponent"
      :to="previousHref || undefined"
      :disabled="previousDisabled || (!previousHref && !previous)"
      :aria-disabled="previousDisabled || (!previousHref && !previous)"
      @click="previous"
    >
      <IconChevronDown />
    </AppButtonIconRounded>

    <span v-if="current && total" class="app-pagination__text tabular-nums">
      {{ current }}
      /
      {{ total }}
    </span>

    <AppButtonIconRounded
      class="app-pagination__next"
      :as="nextComponent"
      :to="nextHref || undefined"
      :disabled="nextDisabled || (!nextHref && !next)"
      :aria-disabled="nextDisabled || (!nextHref && !next)"
      @click="next"
    >
      <IconChevronDown />
    </AppButtonIconRounded>
  </div>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-pagination {
  display: flex;
  align-items: center;
}

.app-pagination__text {
  display: block;
  min-width: 3.75rem;
  margin: 0 0.5rem 0 0;
  font-family: $font-barlow;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
}

.app-pagination--vertical {
  .app-pagination__text {
    margin: 0.5rem 0;
  }

  .app-pagination__prev {
    svg {
      transform: rotate(180deg);
    }
  }

  .app-pagination__next {
    svg {
      transform: rotate(0deg);
    }
  }
}


.app-pagination__prev {
  margin-right: 0.5rem;

  svg {
    transform: rotate(90deg);
  }
}

.app-pagination__next {
  svg {
    transform: rotate(-90deg);
  }
}
</style>
